export const SORTABLE_GRID_LABELS = {
  instructions:
    'Mit den Pfeiltasten einen Eintrag wählen. Leertaste nimmt ihn auf, die Pfeiltasten verschieben ihn, Leertaste legt ihn ab. Escape bricht das Verschieben ab.',
  pickedUp: (name: string, position: number, total: number) =>
    `${name} aufgenommen. Aktuelle Position: ${position} von ${total}.`,
  moved: (name: string, position: number, total: number) =>
    `${name} verschoben auf Position ${position} von ${total}.`,
  dropped: (name: string, position: number, total: number) =>
    `${name} abgelegt auf Position ${position} von ${total}.`,
  cancelled: (name: string, position: number) =>
    `Verschieben abgebrochen. ${name} bleibt auf Position ${position}.`,
};
